export default __webpack_public_path__ + "static/media/login-background.8a30528e.jpg";